import React from 'react';
import styled from '@emotion/styled';
import { UserMenuConsumer } from '../context/UserMenuContext';

const OpenIcon = styled.svg<{ active: boolean }>`
  width: 1rem;
  height: 1rem;
  display: block;
  display: ${p => (p.active ? 'none' : 'inline-block')};
  color: ${p => (p.active ? '#ffffff' : '#4694ce')};
`;

const MenuOpen = () => {
  return (
    <UserMenuConsumer>
      {({ state }) => (
        <OpenIcon data-testid="menu-open-open-icon" active={state.active} viewBox="0 0 125 125">
          <path d="M62.5 114.58a52 52 0 0 1-40.36-19.22c1.35-3.06 4.08-5.18 9.72-6.49 11.69-2.7 23.22-5.11 17.67-15.34C33.11 43.23 44.86 26 62.5 26c17.3 0 29.34 16.55 13 47.49-5.43 10.21 5.69 12.63 17.63 15.39 5.64 1.3 8.39 3.41 9.74 6.46a52 52 0 0 1-40.37 19.24zM62.5 0A62.5 62.5 0 1 0 125 62.5 62.5 62.5 0 0 0 62.5 0z" />
        </OpenIcon>
      )}
    </UserMenuConsumer>
  );
};

export { MenuOpen, MenuOpen as default };
